import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * SessionWarning — Modal overlay shown when the user has been idle for 28 minutes.
 * Gives them 2 minutes to click "Stay Logged In" before automatic logout.
 */
const SessionWarning = () => {
  const { sessionWarning, keepAlive } = useAuth();

  if (!sessionWarning) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Session Expiring</h3>
        <p style={styles.message}>
          You've been inactive for a while. Your session will expire in 2 minutes.
        </p>
        <button onClick={keepAlive} style={styles.button}>
          Stay Logged In
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '32px',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  title: {
    margin: '0 0 12px 0',
    fontSize: '20px',
    color: '#333',
  },
  message: {
    margin: '0 0 24px 0',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.5',
  },
  button: {
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default SessionWarning;
